import { render, staticRenderFns } from "./AssignmentSkills.vue?vue&type=template&id=7b59e1e4&scoped=true&"
import script from "./AssignmentSkills.vue?vue&type=script&lang=js&"
export * from "./AssignmentSkills.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentSkills.vue?vue&type=style&index=0&id=7b59e1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b59e1e4",
  null
  
)

export default component.exports